import {Component, OnInit, Input, AfterViewInit} from '@angular/core';
import { PublicationClass } from 'src/app/Models/Classes/Publications/publication-class';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { PublicationService } from 'src/app/services/publications/publication.service';
import {ActualizacionServiceService} from "../../services/actualizacion/Actualizacion-service.service";
import {
  PublicationMediaTemplateComponent
} from "../../components/publication/publication-media-template/publication-media-template.component";
import {HeaderBarComponent} from 'src/app/components/general-design/header-bar/header-bar.component';
import { FormServiceService } from 'src/app/services/publications/form-service.service';
import { Capacitor } from '@capacitor/core';
@Component({
    selector: 'app-my-feed-page',
    templateUrl: './my-feed-page.page.html',
    styleUrls: ['./my-feed-page.page.scss'],
})
export class MyFeedPagePage implements AfterViewInit {
    private readonly alienLoaderId = 'lk-alien-feed-loader';
    private readonly myFeedPublicationType = 'paraTodos';
    private readonly loaderPhaseMs = 900;
    private loaderPhaseTimeout?: ReturnType<typeof setTimeout>;
    public Profile: any;
    private paginatorIndex: number = 1;
    @Input() profile_id: number;
    @Input() publicationWeb:any;
    valueSelect: string = 'Para todos';
    public publications: any[] = [];
    public isAlienLoading: boolean = true;
    public showPublicationSkeleton: boolean = false;
    public isFetchingNextPage: boolean = false;
    public isRefreshingFeed: boolean = false;
    public isFeedVisible: boolean = true;
    public feedLoadError: 'initial' | 'refresh' | 'pagination' | null = null;
    public hasMorePublications: boolean = true;
    evento;
    mostrar_enlace='Mostrar';
	  mostrar=false;
    private feedTouchStartY: number | null = null;
    private feedTouchStartedOnFirstSlide = false;

    constructor(
     // public HeaderBarComponent: HeaderBarComponent,
        public publicationService: PublicationService,
        private profileService: ProfileService,
        private actualizacionService: ActualizacionServiceService,
        private formService:FormServiceService,

    ) { }

    ngOnInit() {
      this.actualizacionService.current_page=0;
      this.formService.valueSelect = this.valueSelect;
      this.showAlienLoader();
      this.getStories();
      this.getProfile();
      this.loadInitialPublications();
      this.formService.mostrar=false;
    }
 
    ngAfterViewInit() {
    }

    swipe(){
      this.setStoriesVisible(!this.mostrar);
    }

    public setStoriesVisible(visible: boolean): void {
      this.mostrar = visible;
      this.mostrar_enlace = visible ? 'Oculto' : 'Mostrar';
      this.formService.mostrar = visible;
    }

    onFeedTouchStart(event: TouchEvent): void {
      if (Capacitor.getPlatform() !== 'ios') return;
      this.feedTouchStartY = event.touches?.[0]?.clientY ?? null;
      this.feedTouchStartedOnFirstSlide = this.isFirstPublicationSlideActive();
    }

    onFeedTouchEnd(event: TouchEvent): void {
      if (Capacitor.getPlatform() !== 'ios' || this.feedTouchStartY === null) return;
      const endY = event.changedTouches?.[0]?.clientY;
      const distance = typeof endY === 'number' ? endY - this.feedTouchStartY : 0;
      this.feedTouchStartY = null;
      const startedOnFirstSlide = this.feedTouchStartedOnFirstSlide;
      this.feedTouchStartedOnFirstSlide = false;
      if (distance < 64 || this.mostrar || !startedOnFirstSlide || !this.isFirstPublicationSlideActive()) return;
      this.setStoriesVisible(true);
    }

    private isFirstPublicationSlideActive(): boolean {
      const activeSlide = document.querySelector('.publication-media-template-simple .swiper-slide-active');
      if (!activeSlide?.parentElement) return true;
      return Array.from(activeSlide.parentElement.children).indexOf(activeSlide) === 0;
    }

    ionViewDidEnter() {
      this.isFeedVisible = true;
    }

    ionViewWillLeave() {
      this.isFeedVisible = false;
    }

    public doRefresh(event) {
      this.evento=event;
      this.setStoriesVisible(true);
      this.getStories(true);
      this.getPublications(event, true);
    }

    public requestNextPage() {
      if (this.isFetchingNextPage || !this.hasMorePublications) {
        return;
      }

      this.actualizacionService.current_page++;
      this.getPublications(null, false);
    }

    private loadInitialPublications() {
      this.startInitialLoadingState();
      this.feedLoadError = null;
      this.hasMorePublications = true;
      this.actualizacionService.getAIPublications(null, true, null, null, this.myFeedPublicationType, true)
        .then((result: []) => {
          this.publications = result || [];
          this.formService.publications = this.publications;
        })
        .catch(() => {
          this.feedLoadError = 'initial';
        })
        .finally(() => {
          this.finishInitialLoadingState();
        });
    }

    public retryFeed(): void {
      if (this.isAlienLoading || this.isFetchingNextPage || this.isRefreshingFeed) return;
      if (this.feedLoadError === 'pagination') {
        this.requestNextPage();
      } else if (this.feedLoadError === 'refresh') {
        this.getPublications(null, true);
      } else if (this.feedLoadError === 'initial') {
        this.loadInitialPublications();
      }
    }

    public removeNotInterestedPublication(publicationId: number): void {
      this.publications = this.publications.filter(publication => Number(publication?.id) !== Number(publicationId));
      this.formService.publications = this.publications;
      if (this.publications.length === 0 && this.hasMorePublications) {
        this.requestNextPage();
      }
    }

    public getPublications(event: any, firstLoading) {
      const previousHasMore = this.hasMorePublications;
      this.feedLoadError = null;
      if (firstLoading) {
        if (this.publications.length === 0) {
          this.startInitialLoadingState();
        } else {
          this.isRefreshingFeed = true;
        }
        this.hasMorePublications = true;
      } else {
        this.isFetchingNextPage = true;
      }
      this.actualizacionService.getAIPublications(event, firstLoading, null, null, this.myFeedPublicationType, true).then((result: [])=>{
        const fetchedPublications = result || [];

        if (firstLoading) {
          this.publications = fetchedPublications;
        } else if (fetchedPublications.length > 0) {
          this.publications = [...this.publications, ...fetchedPublications];
        } else {
          this.hasMorePublications = false;
        }

        this.formService.publications = this.publications;

        if (firstLoading) {
          this.finishInitialLoadingState();
        }
      }).catch(() => {
        this.hasMorePublications = previousHasMore;
        this.feedLoadError = firstLoading
          ? (this.publications.length > 0 ? 'refresh' : 'initial')
          : 'pagination';
        if (firstLoading) {
          this.finishInitialLoadingState();
        } else {
          this.actualizacionService.current_page = Math.max(1, this.actualizacionService.current_page - 1);
        }
      }).finally(() => {
        this.isRefreshingFeed = false;
        if (!firstLoading) {
          this.isFetchingNextPage = false;
        }
      });
    }

    public getProfile() {
        this.profileService.getProfileInfo().then((data) => {
            this.Profile = JSON.parse(data);
            // The initial Stories request can race profile/session restoration.
            // Refresh once the authenticated profile is available so the bar
            // receives the complete author collection.
            this.publicationService.loadStories(true).catch(() => {
              // The feed remains usable if Stories are temporarily unavailable.
            });
            this.updateAlienLoaderCopy();
        });
    }

    private showAlienLoader() {
      this.hideAlienLoader();
    }

    private updateAlienLoaderCopy() {
      this.hideAlienLoader();
    }

    private hideAlienLoader() {
      const overlay = document.getElementById(this.alienLoaderId);
      if (overlay?.parentNode) {
        overlay.parentNode.removeChild(overlay);
      }
    }

    private startInitialLoadingState() {
      this.clearLoaderPhaseTimeout();
      this.isAlienLoading = true;
      this.showPublicationSkeleton = false;
      this.showAlienLoader();
      this.loaderPhaseTimeout = setTimeout(() => {
        if (this.isAlienLoading) {
          this.showPublicationSkeleton = true;
        }
      }, this.loaderPhaseMs);
    }

    private finishInitialLoadingState() {
      this.clearLoaderPhaseTimeout();
      this.isAlienLoading = false;
      this.showPublicationSkeleton = false;
      this.hideAlienLoader();
    }

    private clearLoaderPhaseTimeout() {
      if (this.loaderPhaseTimeout) {
        clearTimeout(this.loaderPhaseTimeout);
        this.loaderPhaseTimeout = undefined;
      }
    }

    public moreData(event?) {
        this.publicationService.getAllPublications(this.paginatorIndex,null, null).then((data: any) => {
            Object.keys(data.data).forEach(key => {
                let value = data.data[key];
                this.publicationService.updatePublicationList('MyFeedList', value, false);
            });
            this.paginatorIndex++;
            event.target.complete();
            if (data.last_page < this.paginatorIndex) {
                event.target.disabled = true;
            }
        }).catch(error => {
            console.error("Error Get Publications", error);
        });
    }

    public getStories(force = false) {
      this.publicationService.loadStories(force).catch(error => {
        console.error("Error Get Publications", error);
      });
    }

    deletePublication(publication: PublicationClass) { }

}
